import { tokenKeyName } from '../constants';

/**
 * Persist the token, or clear it when given nothing.
 *
 * The write counterpart of `readStoredToken`, and it mirrors that function deliberately:
 *
 * - **Storage is probed at call time, not captured at module load.** The previous `const isClient`
 *   froze the answer the first time the module was imported, which is the same mistake the
 *   `jwtTokenLocalStorage` constant made on the read side.
 * - **`typeof localStorage !== 'undefined'` is not a sufficient guard on its own.** An Android
 *   WebView with site data disabled exposes `localStorage` as **null**, and `typeof null` is
 *   `'object'`, so that check passes and the call throws. That is exactly what crashed
 *   `ServiceProviderWrapper` in production on 02/10/2026.
 *
 * Accepted trade-off: when storage is unavailable the token is simply not persisted, so the session
 * does not survive a reload. There is nothing better to do here, and throwing would take the whole
 * page down (the caller is the auth provider, which wraps the app).
 */
export function setSession(accessToken: string | null | undefined) {
  if (typeof localStorage === 'undefined' || localStorage === null) return;

  try {
    if (accessToken) localStorage.setItem(tokenKeyName, accessToken);
    else localStorage.removeItem(tokenKeyName);
  } catch {
    // Quota exceeded, or a store that exists but refuses writes (privacy modes, sandboxed frames).
  }
}
